export const bplrtFlag =
  process.env.REACT_APP_FLAG_BPLRT === "true" ? true : false;
export const stellarFlag =
  process.env.REACT_APP_FLAG_STELLAR === "true" ? true : false;
